<template>
  <DBox
    :id="'cmp-licencing-licence-sidewindow-income'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new')} ${$t('income')}`"
    @add_click="onAddIncome"
    :rightMenu="[
      {
        text: this.$t('Create Invoice'),
        value: 'create_invoice',
      },
    ]"
    @menuClick="onCreateInvoice"
  >
    <NTable
      class="dbox1"
      id="licencing-licence-sidewindow-income"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td @click="onEditIncome(item)" v-bind="tdcon('date')">
            <span class="ut-link ut-text-accent5">{{
              item["date"]
            }}</span>
          </td>
          <td v-bind="tdcon('period')">
            <span>{{ item["title"] }}</span>
          </td>

          <td v-bind="tdcon('year')">
            <span>{{ item["period"] }}</span>
          </td>
          <td v-bind="tdcon('statement')">
            <span>{{ item["statement"] }}</span>
          </td>
          <td style="text-align: right" v-bind="tdcon('balance')">
            <span style="text-align: right">{{ item["balance"] }}</span>
          </td>
          <td style="text-align: right" v-bind="tdcon('invoice')">
            <span v-if="item['invoice']" style="text-align: right"
              >{{ item["invoice"] + " "
              }}<template v-if="item['currency_iso']">{{
                item["currency_iso"]
              }}</template></span
            >
          </td>
          <td v-bind="tdcon('invoice_no')">
            <template v-if="item['invoice_no']">
              <span
                v-if="item['invoice_id'] > 0"
                @click.stop="onInvoiceClick(item)"
                class="ut-link ut-text-accent5"
                >{{ item["invoice_no"] }}</span
              >
              <span v-else>{{ item["invoice_no"] }}</span>
            </template>
          </td>
          <td v-bind="tdcon('income')">
            <span>{{ item["sys_curr"] }}</span>
          </td>
          <td v-bind="tdcon('options')">
            <div class="dt-icon-container">
              <img
                @click.stop="(e) => deleteIncome(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";

export default {
  props: {
    selectedLicenceDetails: {
      type: Object,
    },
  },
  components: {
    NTable,
    DBox,
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    Headers: function () {
      return [
        createTableHeader("date", {}),
        createTableHeader("period", { text: this.$t("title") }),

        createTableHeader("year", { text:this.$t('period')}),
        createTableHeader("statement", { ta: "right" }),
        createTableHeader("balance", { ta: "right" }),
        createTableHeader("invoice", { ta: "right" }),
        createTableHeader("invoice_no", {}),
        createTableHeader("income", {
          ta: "right",
          text: `${this.$t("income")} ${
            this.$store.getters.account.client.default_currency
          }`,
        }),

        createTableHeader("options", { text: false, mw: 40 }),
      ];
    },

    list: function () {
      return this.selectedLicenceDetails.licence_incomes || [];
    },
  },

  methods: {
    deleteIncome: async function (item) {
      // console.log(":::item", item);

      const confirmationResult = await confirmDelete(
        this.$t("income"),
        `${item["date"]}-${item["period"] || 'x'}-${item["statement"]}`
      );

      if (confirmationResult == "OK") {
        this.$emit("delete", {
          licence_id: item.licence_id,
          licence_line_id: item.licence_line_id,
        });
      }

      // ConfirmationService.create({
      //   subject: `${this.$t("delete_licence_line_msg")}`,
      //   model: true,
      //   width: 500,
      //   completed: (res) => {
      //     switch (res) {
      //       case "OK": {
      //         this.$emit("delete", {
      //           licence_id: item.licence_id,
      //           licence_line_id: item.licence_line_id,
      //         });
      //         break;
      //       }
      //       default: {
      //       }
      //     }
      //   },
      // });
    },

    uniqueCurrencyCheck:function(){
      console.log("PPPPPPPPP",this.list)
      const arr =[...this.list].filter(x=>x.invoice_id==null).map(x=>{
        const invoiceStr = x.invoice.split(" ") 

        return invoiceStr[1]
      })
      const uniqueCount = new Set(arr).size;

      return uniqueCount>1?true:false;
    },
    onCreateInvoice:function(){
      if(this.uniqueCurrencyCheck()){
            NotificationService.showNotification({
            text: this.$t('attention_on_create_licence_invoice'),
            timeout: 5000,
            type: "error"
          });
      }else{
        this.$emit('menu_click')
      }
    },

    onAddIncome:async function () {
      // this.$router.push({
      //   ...this.$route,
      //   query: {
      //     modal: "add_new_asset_modal_income",
      //     licence_id: this.selectedLicenceDetails.licence.licence_id,
      //   },
      // });      if(this.uniqueCurrencyCheck()){


        this.$emit('addIcome')
 


      

      // this.$router.push({
      //   ...this.$route,
      //   query: {
      //     modal: "licence_income_form",
      //     licence_id: this.selectedLicenceDetails.licence.licence_id,
      //     mode: "add",
      //   },
      // });
    },

    onEditIncome: function (item) {
      console.log(item);
      this.$router.push({
        ...this.$route,
        query: {
          modal: "licence_income_form",
          licence_id: this.selectedLicenceDetails.licence.licence_id,
          licence_line_id: item.licence_line_id,
          mode: "edit",
        },
      });
    },

    onInvoiceClick: function (item) {
      console.log(item);
      this.$router.push({
        name: invoiceListLDTRoutes.names.tab,
        params: {
          invoice_id: item.invoice_id,
          tab: "overview",
        },
      });
    },

    // onRightMenuClick: function(menu) {
    //   this.$router.push({
    //     ...this.$route,
    //     query: {
    //       modal: "create_invoice_projects",
    //       external_id: this.selectedLicenceDetails.licence.licence_id
    //       // licence_line_ids:[ ...this.selectedLicenceLines]
    //     }
    //   });
    // }
  },
};
</script>
